import { Button, Group } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';
import { AlertBanner } from '@shipstation/client-common/components/alert-banner';
import { ModalContent } from '@shipstation/client-common/components/modal-content';
import { ModalFooter } from '@shipstation/client-common/components/modal-footer';
import { FormattedMessage, useIntl } from 'react-intl';

import { UsageOverview } from './usage-overview';
import { useOpenUpgradeDrawer } from './hooks/use-open-upgrade-drawer';
import { useCanPurchaseShipmentVolume } from '../../purchase-shipment-volume/use-can-purchase-shipment-volume';
import { messages } from '../../purchase-shipment-volume/messages';

type UpgradeRequiredContentProps = {
  onClose: () => void;
  isAtLimit: boolean;
  usagePercentage: number;
  totalUsage: number;
  shipmentLimit: number;
  planName: string;
};

export const UpgradeRequiredContent = ({
  onClose,
  isAtLimit,
  usagePercentage,
  totalUsage,
  shipmentLimit,
  planName,
}: UpgradeRequiredContentProps) => {
  const intl = useIntl();
  const { isValidPlan } = useCanPurchaseShipmentVolume();
  const { handleManagePlan, maxPlanShipmentLimit } = useOpenUpgradeDrawer(onClose);

  const upgradeMessage = isValidPlan ? messages.upgradeVolumeMessage : messages.upgradePlansMessage;

  return (
    <>
      <ModalContent>
        <UsageOverview
          bodyMessage={messages.noTiersAvailableBody}
          isHighLimitWarning={false}
          isMediumLimitWarning={false}
          isAtLimit={isAtLimit}
          planName={planName}
          shipmentLimit={shipmentLimit}
          totalUsage={totalUsage}
          usagePercentage={usagePercentage}
        />
        {!isAtLimit ? (
          <AlertBanner
            description={<FormattedMessage {...upgradeMessage} values={{ max: intl.formatNumber(maxPlanShipmentLimit) }} />}
            status='upgrade'
          />
        ) : null}
      </ModalContent>
      <ModalFooter>
        <Group justify='space-between' w='100%'>
          <Button onClick={onClose} variant='ghost'>
            <FormattedMessage {...messages.cancel} />
          </Button>
          <Button color='upgrade' onClick={handleManagePlan} variant='primary'>
            <FontAwesomeIcon icon={faBolt} />
            <FormattedMessage {...messages.upgrade} />
          </Button>
        </Group>
      </ModalFooter>
    </>
  );
};
